import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  Row,
  Select,
  Tabs,
  Typography,
  Upload,
  Collapse,
  Table,
  Checkbox,
  InputNumber,
  Radio,
} from "antd";
import { toast } from "react-toastify";
import { PlusOutlined } from "@ant-design/icons";
import { Fragment, useEffect, useMemo, useState } from "react";
import moment from "moment";
import getCompanyIdFromToken from "../../utils/getCompanyIdFromToken";
import Loader from "../loader/loader";
import {
  getAllMaster,
  getCitiesByStateId,
} from "../../redux/rtk/features/masters/masterSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  addCompanyBasicDetailsSetup,
  CompanyRegistrationDetailsSetup,
  CompanyBankDetailsSetup,
  CompanyOtherDetailsSetup,
  CompanyDetailsGetbyId,
  CompanyDetailsGetbyClient,
  CompanyOfficeDetailsSetup,
  CompanyOfficeDetailsGetbyCompanyId,
} from "../../redux/rtk/features/settingSlice/settingSlice";
import EmailConfiguration from "../user/Email.js/emailConfig";

const BASE_URL =
  process.env.REACT_APP_API?.replace(/^["']|["']$/g, '') || "https://hrmsapi.softomation.com";

const { TabPane } = Tabs;
const { Title } = Typography;
const { Option } = Select;
const { Panel } = Collapse;

const sortByField = (items = [], field) =>
  [...items].sort((a, b) =>
    String(a[field] ?? "").localeCompare(String(b[field] ?? ""), undefined, {
      sensitivity: "base",
    })
  );

const SEARCHABLE_SELECT_PROPS = {
  showSearch: true,
  optionFilterProp: "label",
  filterOption: (input, option) =>
    String(option?.label ?? "")
      .toLowerCase()
      .includes(input.trim().toLowerCase()),
};

const normalizeCompanyDetails = (details) => {
  if (!details) return null;
  if (Array.isArray(details)) {
    return details.length ? details[0] : null;
  }
  return details;
};

const getRegisteredAddress = (details) => {
  const company = normalizeCompanyDetails(details) || {};
  return {
    AddressId: company.AddressId ?? 0,
    StreetAddress:
      company.RegisteredStreetAddress ?? company.StreetAddress ?? "",
    StateId: company.RegisteredStateId ?? company.StateId,
    CityId: company.RegisteredCityId ?? company.CityId,
    CountryId: company.RegisteredCountryId ?? company.CountryId,
    ZipCode: company.RegisteredZipCode ?? company.ZipCode ?? "",
  };
};

const toSelectNumber = (value) =>
  value === null || value === undefined || value === ""
    ? undefined
    : Number(value);

const AddDetails = () => {
  const CompanyId = getCompanyIdFromToken();
  const [loader, setLoader] = useState(false);
  const dispatch = useDispatch();
  const [basicForm] = Form.useForm();
  const [bankForm] = Form.useForm();
  const [setupForm] = Form.useForm();
  const [documentForm] = Form.useForm();
  const [officeForm] = Form.useForm();
  const [modalForm] = Form.useForm();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [thumbFileList, setThumbFileList] = useState([]);
  const [bankEntries, setBankEntries] = useState([{}]);
  const [documentEntries, setDocumentEntries] = useState([{}]);
  const [selectedRoles, setSelectedRoles] = useState([]);
  const [selectedEmploymentTypes, setSelectedEmploymentTypes] = useState([]);
  const [selectedShifts, setSelectedShifts] = useState([]);
  const [selectedLeaveTypes, setSelectedLeaveTypes] = useState([]);
  const [selectedGrades, setSelectedGrades] = useState([]);
  const [selectedDepartments, setSelectedDepartments] = useState([]);
  const [selectedDesignations, setSelectedDesignations] = useState([]);
  const [base64Logo, setBase64Logo] = useState("");
  const [selectedOfficeType, setSelectedOfficeType] = useState(null);
  const [companyId, setCompanyId] = useState(CompanyId);
  const [appraisalYearType, setAppraisalYearType] = useState("calendar");
  const [leaveYearType, setLeaveYearType] = useState("calendar");
  const [officeEntries, setOfficeEntries] = useState([]);
  const [isAddingNewCompany, setIsAddingNewCompany] = useState(false);
  const masterData = useSelector((state) => state.masters.masters);
  const cities = useSelector((state) => state.masters.cities);
  const loading = useSelector((state) => state.masters.loading);
  const companyDetails = useSelector((state) => state.setting.list);
  // console.log("companyDetails", companyDetails);
  
  const clientCompanyData = useSelector(
    (state) => state.setting.clientCompanyData
  );

  useEffect(() => {
    dispatch(getAllMaster());
    dispatch(CompanyDetailsGetbyClient());
    dispatch(CompanyOfficeDetailsGetbyCompanyId(companyId));
    dispatch(CompanyDetailsGetbyId(companyId || null));

    // if (companyId) {
    //   dispatch(CompanyDetailsGetbyId(companyId));
    // }
  }, [dispatch, companyId]);

  useEffect(() => {
    const company = normalizeCompanyDetails(companyDetails);
    if (company && !isAddingNewCompany) {
      const registeredAddress = getRegisteredAddress(company);
      setCompanyId(company.CompanyId);

      // Prefill Basic Info Form
      basicForm.setFieldsValue({
        selectedCompany: company.CompanyId,
        CompanyName: company.CompanyName,
        CompanyTypeId: company.CompanyTypeId,
        AddressId: registeredAddress.AddressId,
        address: registeredAddress.StreetAddress,
        state: toSelectNumber(registeredAddress.StateId),
        city: toSelectNumber(registeredAddress.CityId),
        country: toSelectNumber(registeredAddress.CountryId),
        phone: company.PhoneNumber,
        email: company.EmailId,
        website: company.WebsiteUrl,
        gst_number: company.GstNumber,
        tan_number: company.TanNumber,
        pf_number: company.PfNumber,
        ZipCode: registeredAddress.ZipCode?.toString(),
        TagLine: company.TagLine,
        FooterTagLine: company.FooterTagLine,
      });

      if (registeredAddress.StateId) {
        dispatch(getCitiesByStateId(registeredAddress.StateId));
      }

      if (company.LogoPath) {
        const logoUrl = company.LogoPath.startsWith("http")
          ? company.LogoPath
          : `${BASE_URL}/${company.LogoPath.replace(/^\//, "")}`;

        setThumbFileList([
          {
            uid: "-1",
            name: company.LogoPath.split("/").pop(),
            status: "done",
            url: logoUrl,
          },
        ]);
        setBase64Logo(logoUrl);
      }

      // Prefill Bank Info Form
      if (company.BankDetails && company.BankDetails.length > 0) {
        setBankEntries(company.BankDetails);
        bankForm.setFieldsValue({
          bankEntries: company.BankDetails.map((bank) => ({
            accountName: bank.AccountHolderName,
            accountNumber: bank.AccountNumber,
            BankTypeId: bank.BankTypeId,
            openingBalance: bank.OpeningBalance,
            asOnDate: bank.CreatedDate ? moment(bank.CreatedDate) : null,
          })),
        });
      }

      // Prefill Setup Form
      setupForm.setFieldsValue({
        financialYearId: company.FinancialStartMonthId,
        appraisalYearType:
          company.AppraisalStartMonthId === company.FinancialStartMonthId
            ? "financial"
            : "calendar",
        leaveYearType:
          company.LeaveStartMonthId === company.FinancialStartMonthId
            ? "financial"
            : "calendar",
      });

      setSelectedRoles(
        company.DefaultRoleIds
          ? company.DefaultRoleIds.split(",").map(Number)
          : []
      );
      setSelectedEmploymentTypes(
        company.DefaultEmploymentTypeIds
          ? company.DefaultEmploymentTypeIds.split(",").map(Number)
          : []
      );
      setSelectedLeaveTypes(
        company.DefaultLeaveTypeIds
          ? company.DefaultLeaveTypeIds.split(",").map(Number)
          : []
      );
      setSelectedDepartments(
        company.DefaultDepartmentIds
          ? company.DefaultDepartmentIds.split(",").map(Number)
          : []
      );
      setSelectedDesignations(
        company.DefaultDesignationIds
          ? company.DefaultDesignationIds.split(",").map(Number)
          : []
      );
      setAppraisalYearType(
        company.AppraisalStartMonthId === company.FinancialStartMonthId
          ? "financial"
          : "calendar"
      );
      setLeaveYearType(
        company.LeaveStartMonthId === company.FinancialStartMonthId
          ? "financial"
          : "calendar"
      );

      if (company.OfficeDetails && company.OfficeDetails.length > 0) {
      const officeData = company.OfficeDetails.map((office) => ({
        CompanyOfficeId: office.CompanyOfficeId,
        OfficeTypeId: office.OfficeTypeId,
        CompanyOfficeName: office.CompanyOfficeName,
        EmployeeCodePrefix: office.EmployeeCodePrefix,
        GstNumber: office.GstNumber,
        EmailId: office.EmailId,
        PhoneNumber: office.PhoneNumber,
        StreetAddress:
          office.RegisteredStreetAddress ?? office.StreetAddress ?? "",
        CityId: toSelectNumber(office.RegisteredCityId ?? office.CityId),
        StateId: toSelectNumber(office.RegisteredStateId ?? office.StateId),
        CountryId: toSelectNumber(
          office.RegisteredCountryId ?? office.CountryId
        ),
        ZipCode: (office.RegisteredZipCode ?? office.ZipCode)?.toString(),
      }));

      setOfficeEntries(officeData);
      officeForm.setFieldsValue({
        officeEntries: officeData,
      });

      // Set selected office type for the first office (or handle dynamically if multiple)
      if (officeData.length > 0) {
        setSelectedOfficeType(officeData[0].OfficeTypeId);
      }

      // Optionally, fetch cities for the selected state
      if (officeData[0]?.StateId) {
        handleOfficeStateChange(officeData[0].StateId, 0);
      }
    }
  
    }
  }, [companyDetails, basicForm, bankForm, setupForm, isAddingNewCompany]);

  const showModal = () => setIsModalVisible(true);
  const handleCancel = () => {
    setIsModalVisible(false);
    modalForm.resetFields();
  };

  const addBankEntry = () => setBankEntries([...bankEntries, {}]);
  const removeBankEntry = (index) => {
    const newEntries = bankEntries.filter((_, i) => i !== index);
    setBankEntries(newEntries);
  };

  const addOfficeEntry = () => setOfficeEntries([...officeEntries, {}]);
  const removeOfficeEntry = (index) => {
    const newEntries = officeEntries.filter((_, i) => i !== index);
    setOfficeEntries(newEntries);
  };

  const handleCompanyChange = (selectedCompanyId) => {
    if (selectedCompanyId === "add_new") {
      setIsAddingNewCompany(true);
      handleAddNewDetails();
      basicForm.resetFields();
      bankForm.resetFields();
      setupForm.resetFields();
    } else {
      setIsAddingNewCompany(false);
      setCompanyId(selectedCompanyId);
      // if (selectedCompanyId) {
      //   dispatch(CompanyDetailsGetbyId(selectedCompanyId));
      // }
    }
  };

  const handleImageUpload = ({ fileList }) => {
    setThumbFileList(fileList);
    if (fileList.length > 0) {
      const file = fileList[0].originFileObj;
      if (file) {
        const reader = new FileReader();
        reader.onloadend = () => {
          setBase64Logo(reader.result);
        };
        reader.readAsDataURL(file);
      }
    } else {
      setBase64Logo("");
    }
  };

  const handleAddNewDetails = () => {
    setLoader(true);
    try {
      // Reset all forms
      basicForm.resetFields();
      bankForm.resetFields();
      setupForm.resetFields();
      documentForm.resetFields();
      modalForm.resetFields();
      officeForm.resetFields();

      // Reset all state variables
      setCompanyId(null);
      setBase64Logo("");
      setThumbFileList([]);
      setBankEntries([{}]);
      setDocumentEntries([{}]);
      setSelectedRoles([]);
      setSelectedEmploymentTypes([]);
      setSelectedShifts([]);
      setSelectedLeaveTypes([]);
      setSelectedGrades([]);
      setSelectedDepartments([]);
      setSelectedDesignations([]);
      setAppraisalYearType("calendar");
      setLeaveYearType("calendar");
      setOfficeEntries([{}]);
      setIsAddingNewCompany(true);

      toast.success("Form reset for adding new company details");
    } catch (error) {
      toast.error("Failed to reset form");
      // console.error(error);
    } finally {
      setLoader(false);
    }
  };

  const filteredRoles =
    masterData?.RoleDetails?.filter((role) => role.CompanyId === "0") || [];
  const filteredEmploymentTypes = masterData?.EmploymentTypeMaster || [];
  const filteredShifts = masterData?.ShiftDetails || [];
  const filteredLeaveTypes =
    masterData?.LeaveTypeMaster?.filter((leave) => leave.CompanyId === "0") ||
    [];
  // const filteredDepartments =
  //   masterData?.DepartmentMaster?.filter(
  //     (dept) =>
  //       selectedGrades.includes(dept.GradeTypeId) && dept.DataStatus === 1
  //   ) || [];
  // const filteredDesignations =
  //   masterData?.DesignationMaster?.filter(
  //     (desg) =>
  //       selectedDepartments.includes(desg.DepartmentId) && desg.DataStatus === 1
  //   ) || [];
  const filteredDepartments =
    masterData?.DepartmentMaster?.filter((dept) => dept.DataStatus === 1) || [];
  const filteredDesignations =
    masterData?.DesignationMaster?.filter((desg) => desg.DataStatus === 1) ||
    [];

  const sortedClientCompanies = useMemo(
    () => sortByField(clientCompanyData || [], "CompanyName"),
    [clientCompanyData]
  );

  const sortedCompanyTypes = useMemo(
    () =>
      sortByField(
        masterData?.CompanyTypeMaster?.filter((type) => type.DataStatus === 1) ||
          [],
        "CompanyTypeName"
      ),
    [masterData?.CompanyTypeMaster]
  );

  const sortedStates = useMemo(
    () =>
      sortByField(
        masterData?.StatesMaster?.filter((state) => state.DataStatus === 1) ||
          [],
        "StateName"
      ),
    [masterData?.StatesMaster]
  );

  const sortedCities = useMemo(
    () => sortByField(cities || [], "CityName"),
    [cities]
  );

  useEffect(() => {
    const company = normalizeCompanyDetails(companyDetails);
    if (!company || isAddingNewCompany || !sortedCities.length) {
      return;
    }

    const cityId = toSelectNumber(getRegisteredAddress(company).CityId);
    if (cityId) {
      basicForm.setFieldsValue({ city: cityId });
    }
  }, [sortedCities, companyDetails, isAddingNewCompany, basicForm]);

  const sortedCountries = useMemo(
    () =>
      sortByField(
        masterData?.CountriesMaster?.filter(
          (country) => country.DataStatus === 1
        ) || [],
        "CountryName"
      ),
    [masterData?.CountriesMaster]
  );

  const sortedBanks = useMemo(
    () =>
      sortByField(
        masterData?.BankTypeMaster?.filter((bank) => bank.DataStatus === 1) ||
          [],
        "BankTypeName"
      ),
    [masterData?.BankTypeMaster]
  );

  const sortedMonths = useMemo(
    () =>
      sortByField(
        masterData?.MonthMaster?.filter((month) => month.DataStatus === 1) || [],
        "MonthName"
      ),
    [masterData?.MonthMaster]
  );

  const sortedOfficeTypes = useMemo(
    () =>
      sortByField(
        masterData?.OfficeTypeMaster?.filter((type) => type.DataStatus === 1) ||
          [],
        "OfficeTypeName"
      ),
    [masterData?.OfficeTypeMaster]
  );

  const handleStateChange = (stateId) => {
    if (stateId) {
      dispatch(getCitiesByStateId(stateId));
      basicForm.setFieldsValue({
        city: undefined, // Reset city when state changes
      });
      // Optionally set country based on state
      const selectedState = masterData?.StatesMaster?.find(
        (state) => state.StateId === stateId
      );
      if (selectedState) {
        const country = masterData?.CountriesMaster?.find(
          (country) => country.CountryId === selectedState.CountryId
        );
        if (country) {
          basicForm.setFieldsValue({
            country: country.CountryId,
          });
        }
      }
    } else {
      basicForm.setFieldsValue({
        city: undefined,
        country: undefined,
      });
    }
  };

  const handleOfficeStateChange = (stateId, index) => {
    const selectedState = masterData?.StatesMaster?.find(
      (state) => state.StateId === stateId
    );
    if (selectedState) {
      const country = masterData?.CountriesMaster?.find(
        (country) => country.CountryId === selectedState.CountryId
      );
      if (country) {
        officeForm.setFieldsValue({
          officeEntries: officeEntries.map((entry, i) =>
            i === index
              ? {
                  ...entry,
                  OfficeTypeId: selectedOfficeType,
                  CountryId: country.CountryId,
                  CityId: undefined,
                }
              : entry
          ),
        });
      }
      dispatch(getCitiesByStateId(stateId));
    }
  };

  const onFinishBasic = async (values) => {
    setLoader(true);
    try {
      const company = normalizeCompanyDetails(companyDetails) || {};
      const isUpdate = !!companyId;
      const basicDetails = {
        CompanyId: isUpdate ? companyId : 0,
        CompanyTypeId: values.CompanyTypeId,
        CompanyName: values.CompanyName,
        CompanyCode: values.CompanyCode || "",
        TagLine: values.TagLine || "",
        WebsiteUrl: values.website || "",
        LogoPath: base64Logo || "",
        FooterTagLine: values.FooterTagLine || "",
        AddressId: values.AddressId || company.AddressId || 0,
        ContactId: 0,
        StreetAddress: values.address || "",
        CityId: values.city || 0,
        StateId: values.state || 0,
        CountryId: values.country || 0,
        ZipCode: values.ZipCode || "",
        EmailId: values.email,
        PhoneNumber: values.phone,
        DataStatus: 1,
        CreatedBy: isUpdate ? company.CreatedBy || "0" : "0",
        ModifiedBy: "0",
      };

      const basicResponse = await dispatch(
        addCompanyBasicDetailsSetup(basicDetails)
      ).unwrap();
      if (basicResponse.message === "error") {
        throw new Error("Failed to save basic details");
      }

      const newCompanyId = isUpdate
        ? companyId
        : basicResponse.data?.CompanyId || 1;
      setCompanyId(newCompanyId);
      setIsAddingNewCompany(false);

      const registrationDetails = {
        CompanyId: newCompanyId,
        GstNumber: values.gst_number || "",
        TanNumber: values.tan_number || "",
        PfNumber: values.pf_number || "",
        DataStatus: 1,
        CreatedBy: isUpdate ? company.CreatedBy || "0" : "0",
        ModifiedBy: "0",
      };

      const registrationResponse = await dispatch(
        CompanyRegistrationDetailsSetup(registrationDetails)
      ).unwrap();
      if (registrationResponse.message === "error") {
        throw new Error("Failed to save registration details");
      }

      await dispatch(CompanyDetailsGetbyId(newCompanyId));

      toast.success(
        `Basic details ${isUpdate ? "updated" : "saved"} successfully`
      );
      if (!isUpdate) {
        basicForm.resetFields();
        setBase64Logo("");
        setThumbFileList([]);
      }
    } catch (error) {
      toast.error(`Failed to ${companyId ? "update" : "save"} basic details`);
      // console.error(error);
    } finally {
      setLoader(false);
    }
  };

  const onFinishBank = async (values) => {
    if (!companyId) {
      toast.warning("Please save Basic Info first to generate a Company ID");
      return;
    }
    setLoader(true);
    try {
      const bankDetails =
        values.bankEntries?.map((entry, index) => ({
          BankId: bankEntries[index]?.BankId || 0,
          CompanyId: companyId,
          BankTypeId: entry.BankTypeId,
          BranchName: entry.accountName || "",
          IfscCode: entry.IfscCode || "",
          MicrCode: entry.MicrCode || "",
          BankAddress: entry.BankAddress || "",
          PanNumber: entry.PanNumber || "",
          UpiId: entry.UpiId || "",
          AccountHolderName: entry.accountName,
          AccountNumber: entry.accountNumber,
          AccountTypeId: entry.AccountTypeId || 1,
          OpeningBalance: entry.openingBalance || 0,
          DataStatus: 1,
          CreatedBy: bankEntries[index]?.CreatedBy || "0",
          ModifiedBy: bankEntries[index]?.BankId ? "0" : "0",
        })) || [];

      for (const bankEntry of bankDetails) {
        const bankResponse = await dispatch(
          CompanyBankDetailsSetup(bankEntry)
        ).unwrap();
        if (bankResponse.message === "error") {
          throw new Error("Failed to save bank details");
        }
      }

      toast.success(
        `Bank details ${
          bankDetails.some((b) => b.BankId) ? "updated" : "saved"
        } successfully`
      );
      bankForm.resetFields();
      setBankEntries([{}]);
    } catch (error) {
      toast.error(
        `Failed to ${
          bankEntries.some((b) => b.BankId) ? "update" : "save"
        } bank details`
      );
      // console.error(error);
    } finally {
      setLoader(false);
    }
  };

  const onFinishSetup = async (values) => {
    if (!companyId) {
      toast.warning("Please save Basic Info first to generate a Company ID");
      return;
    }
    setLoader(true);
    try {
      const otherDetails = {
        CompanyId: companyId,
        FinancialStartMonthId: values.financialYearId || 0,
        AppraisalStartMonthId:
          appraisalYearType === "financial" ? values.financialYearId : 1,
        LeaveStartMonthId:
          leaveYearType === "financial" ? values.financialYearId : 1,
        DefaultRoleIds: selectedRoles.length > 0 ? selectedRoles : [],
        DefaultEmploymentTypeIds:
          selectedEmploymentTypes.length > 0 ? selectedEmploymentTypes : [],
        DefaultLeaveTypeIds:
          selectedLeaveTypes.length > 0 ? selectedLeaveTypes : [],
        DefaultDepartmentIds:
          selectedDepartments.length > 0 ? selectedDepartments : [],
        DefaultDesignationIds:
          selectedDesignations.length > 0 ? selectedDesignations : [],
        DataStatus: 1,
        CreatedBy: companyDetails?.CreatedBy || "0",
        ModifiedBy: "0",
      };

      const otherResponse = await dispatch(
        CompanyOtherDetailsSetup(otherDetails)
      ).unwrap();
      if (otherResponse.message === "error") {
        throw new Error("Failed to save company setup details");
      }

      toast.success("Company setup details saved successfully");
      setupForm.resetFields();
      setSelectedRoles([]);
      setSelectedEmploymentTypes([]);
      setSelectedShifts([]);
      setSelectedLeaveTypes([]);
      setSelectedDepartments([]);
      setSelectedDesignations([]);
      setAppraisalYearType("calendar");
      setLeaveYearType("calendar");
    } catch (error) {
      toast.error("Failed to save company setup details");
      // console.error(error);
    } finally {
      setLoader(false);
    }
  };

  const onFinishOffice = async (values) => {
    if (!companyId) {
      toast.warning("Please save Basic Info first to generate a Company ID");
      return;
    }
    setLoader(true);
    try {
      const officeDetails =
        values.officeEntries?.map((entry, index) => ({
          CompanyOfficeId: officeEntries[index]?.CompanyOfficeId || 0,
          CompanyId: companyId,
          OfficeTypeId: entry.OfficeTypeId,
          CompanyOfficeName: entry.CompanyOfficeName,
          EmployeeCodePrefix: entry.EmployeeCodePrefix,
          GstNumber: entry.GstNumber || "",
          AddressId: 0,
          ContactId: 0,
          EmailId: entry.EmailId || "",
          PhoneNumber: entry.PhoneNumber || "",
          StreetAddress: entry.StreetAddress || "",
          CityId: entry.CityId || 0,
          StateId: entry.StateId || 0,
          CountryId: entry.CountryId || 0,
          ZipCode: entry.ZipCode || 0,
          DataStatus: 1,
          CreatedBy: officeEntries[index]?.CreatedBy || "0",
          ModifiedBy: officeEntries[index]?.CompanyOfficeId ? "0" : "0",
        })) || [];

      for (const officeEntry of officeDetails) {
        const officeResponse = await dispatch(
          CompanyOfficeDetailsSetup(officeEntry)
        ).unwrap();
        if (officeResponse.message === "error") {
          throw new Error("Failed to save office details");
        }
      }

      toast.success(
        `Office details ${
          officeDetails.some((o) => o.CompanyOfficeId) ? "updated" : "saved"
        } successfully`
      );
      officeForm.resetFields();
      setOfficeEntries([{}]);
    } catch (error) {
      toast.error(
        `Failed to ${
          officeEntries.some((o) => o.CompanyOfficeId) ? "update" : "save"
        } office details`
      );
      // console.error(error);
    } finally {
      setLoader(false);
    }
  };

  // const gradeColumns = [
  //   {
  //     title: "Select",
  //     key: "select",
  //     render: (_, record) => (
  //       <Checkbox
  //         checked={selectedGrades.includes(record.GradeTypeId)}
  //         onChange={(e) => {
  //           if (e.target.checked) {
  //             setSelectedGrades([...selectedGrades, record.GradeTypeId]);
  //             setSelectedDepartments([]);
  //             setSelectedDesignations([]);
  //           } else {
  //             const newGrades = selectedGrades.filter(
  //               (id) => id !== record.GradeTypeId
  //             );
  //             setSelectedGrades(newGrades);
  //             if (newGrades.length === 0) {
  //               setSelectedDepartments([]);
  //               setSelectedDesignations([]);
  //             }
  //           }
  //         }}
  //       />
  //     ),
  //   },
  //   {
  //     title: "Grade Name",
  //     dataIndex: "GradeTypeName",
  //     key: "GradeTypeName",
  //     sorter: (a, b) => a.GradeTypeName.localeCompare(b.GradeTypeName),
  //   },
  //   {
  //     title: "Status",
  //     dataIndex: "DataStatus",
  //     key: "DataStatus",
  //     render: (status) => (status === 1 ? "Active" : "Inactive"),
  //   },
  // ];

  const departmentColumns = [
    {
      title: "Select",
      key: "select",
      render: (_, record) => (
        <Checkbox
          checked={selectedDepartments.includes(record.DepartmentId)}
          onChange={(e) => {
            if (e.target.checked) {
              setSelectedDepartments([
                ...selectedDepartments,
                record.DepartmentId,
              ]);
            } else {
              setSelectedDepartments(
                selectedDepartments.filter((id) => id !== record.DepartmentId)
              );
            }
          }}
        />
      ),
    },
    {
      title: "Department Name",
      dataIndex: "DepartmentName",
      key: "DepartmentName",
      sorter: (a, b) => a.DepartmentName.localeCompare(b.DepartmentName),
    },
    {
      title: "Status",
      dataIndex: "DataStatus",
      key: "DataStatus",
      render: (status) => (status === 1 ? "Active" : "Inactive"),
    },
  ];

  const designationColumns = [
    {
      title: "Select",
      key: "select",
      render: (_, record) => (
        <Checkbox
          checked={selectedDesignations.includes(record.DesignationId)}
          onChange={(e) => {
            if (e.target.checked) {
              setSelectedDesignations([
                ...selectedDesignations,
                record.DesignationId,
              ]);
            } else {
              setSelectedDesignations(
                selectedDesignations.filter((id) => id !== record.DesignationId)
              );
            }
          }}
        />
      ),
    },
    {
      title: "Designation Name",
      dataIndex: "DesignationName",
      key: "DesignationName",
      sorter: (a, b) => a.DesignationName.localeCompare(b.DesignationName),
    },
    {
      title: "Status",
      dataIndex: "DataStatus",
      key: "DataStatus",
      render: (status) => (status === 1 ? "Active" : "Inactive"),
    },
  ];

  const handleSelectAllGrades = (e) => {
    if (e.target.checked) {
      const allGradeIds =
        masterData?.GradeTypeMaster?.filter(
          (grade) => grade.DataStatus === 1
        ).map((grade) => grade.GradeTypeId) || [];
      setSelectedGrades(allGradeIds);
      setSelectedDepartments([]);
      setSelectedDesignations([]);
    } else {
      setSelectedGrades([]);
      setSelectedDepartments([]);
      setSelectedDesignations([]);
    }
  };

  const handleSelectAllDepartments = (e) => {
    if (e.target.checked) {
      const allDepartmentIds =
        filteredDepartments.map((dept) => dept.DepartmentId) || [];
      setSelectedDepartments(allDepartmentIds);
      setSelectedDesignations([]);
    } else {
      setSelectedDepartments([]);
      setSelectedDesignations([]);
    }
  };

  const handleSelectAllDesignations = (e) => {
    if (e.target.checked) {
      const allDesignationIds =
        filteredDesignations.map((desg) => desg.DesignationId) || [];
      setSelectedDesignations(allDesignationIds);
    } else {
      setSelectedDesignations([]);
    }
  };

  const roleColumns = [
    {
      title: "Select",
      key: "select",
      render: (_, record) => (
        <Checkbox
          checked={selectedRoles.includes(record.RoleId)}
          onChange={(e) => {
            if (e.target.checked) {
              setSelectedRoles([...selectedRoles, record.RoleId]);
            } else {
              setSelectedRoles(
                selectedRoles.filter((id) => id !== record.RoleId)
              );
            }
          }}
        />
      ),
    },
    {
      title: "Role Name",
      dataIndex: "RoleName",
      key: "RoleName",
      sorter: (a, b) => a.RoleName.localeCompare(b.RoleName),
    },
    {
      title: "Status",
      dataIndex: "DataStatus",
      key: "DataStatus",
      render: (status) => (status === 1 ? "Active" : "Inactive"),
    },
  ];

  const employmentTypeColumns = [
    {
      title: "Select",
      key: "select",
      render: (_, record) => (
        <Checkbox
          checked={selectedEmploymentTypes.includes(record.EmploymentTypeId)}
          onChange={(e) => {
            if (e.target.checked) {
              setSelectedEmploymentTypes([
                ...selectedEmploymentTypes,
                record.EmploymentTypeId,
              ]);
            } else {
              setSelectedEmploymentTypes(
                selectedEmploymentTypes.filter(
                  (id) => id !== record.EmploymentTypeId
                )
              );
            }
          }}
        />
      ),
    },
    {
      title: "Employment Type",
      dataIndex: "EmploymentTypeName",
      key: "EmploymentTypeName",
      sorter: (a, b) =>
        a.EmploymentTypeName.localeCompare(b.EmploymentTypeName),
    },
    {
      title: "Status",
      dataIndex: "DataStatus",
      key: "DataStatus",
      render: (status) => (status === 1 ? "Active" : "Inactive"),
    },
  ];

  const shiftColumns = [
    {
      title: "Select",
      key: "select",
      render: (_, record) => (
        <Checkbox
          checked={selectedShifts.includes(record.ShiftId)}
          onChange={(e) => {
            if (e.target.checked) {
              setSelectedShifts([...selectedShifts, record.ShiftId]);
            } else {
              setSelectedShifts(
                selectedShifts.filter((id) => id !== record.ShiftId)
              );
            }
          }}
        />
      ),
    },
    {
      title: "Shift Name",
      dataIndex: "ShiftName",
      key: "ShiftName",
      sorter: (a, b) => a.ShiftName.localeCompare(b.ShiftName),
    },
    {
      title: "Start Time",
      dataIndex: "StartTime",
      key: "StartTime",
      render: (time) =>
        new Date(time).toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        }),
    },
    {
      title: "End Time",
      dataIndex: "EndTime",
      key: "EndTime",
      render: (time) =>
        new Date(time).toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        }),
    },
    {
      title: "Punch In Grace (min)",
      dataIndex: "PunchInGrace",
      key: "PunchInGrace",
    },
    {
      title: "Status",
      dataIndex: "DataStatus",
      key: "DataStatus",
      render: (status) => (status === 1 ? "Active" : "Inactive"),
    },
  ];

  const leaveTypeColumns = [
    {
      title: "Select",
      key: "select",
      render: (_, record) => (
        <Checkbox
          checked={selectedLeaveTypes.includes(record.LeaveTypeId)}
          onChange={(e) => {
            if (e.target.checked) {
              setSelectedLeaveTypes([
                ...selectedLeaveTypes,
                record.LeaveTypeId,
              ]);
            } else {
              setSelectedLeaveTypes(
                selectedLeaveTypes.filter((id) => id !== record.LeaveTypeId)
              );
            }
          }}
        />
      ),
    },
    {
      title: "Leave Type",
      dataIndex: "LeaveTypeName",
      key: "LeaveTypeName",
      sorter: (a, b) => a.LeaveTypeName.localeCompare(b.LeaveTypeName),
    },
    {
      title: "Description",
      dataIndex: "LeaveTypeDescription",
      key: "LeaveTypeDescription",
      render: (text) => text || "N/A",
    },
    {
      title: "Status",
      dataIndex: "DataStatus",
      key: "DataStatus",
      render: (status) => (status === 1 ? "Active" : "Inactive"),
    },
  ];

  const handleSelectAllRoles = (e) => {
    if (e.target.checked) {
      const allRoleIds = filteredRoles.map((role) => role.RoleId) || [];
      setSelectedRoles(allRoleIds);
    } else {
      setSelectedRoles([]);
    }
  };

  const handleSelectAllEmploymentTypes = (e) => {
    if (e.target.checked) {
      const allEmploymentTypeIds =
        filteredEmploymentTypes.map((type) => type.EmploymentTypeId) || [];
      setSelectedEmploymentTypes(allEmploymentTypeIds);
    } else {
      setSelectedEmploymentTypes([]);
    }
  };

  const handleSelectAllShifts = (e) => {
    if (e.target.checked) {
      const allShiftIds = filteredShifts.map((shift) => shift.ShiftId) || [];
      setSelectedShifts(allShiftIds);
    } else {
      setSelectedShifts([]);
    }
  };

  const handleSelectAllLeaveTypes = (e) => {
    if (e.target.checked) {
      const allLeaveTypeIds =
        filteredLeaveTypes.map((leave) => leave.LeaveTypeId) || [];
      setSelectedLeaveTypes(allLeaveTypeIds);
    } else {
      setSelectedLeaveTypes([]);
    }
  };

  return (
    <Fragment>
      <Row className="mt-2">
        <Col
          xs={24}
          sm={24}
          md={24}
          lg={24}
          className="border rounded shadow-lg bg-white p-4"
        >
          <Title level={4} className="text-center text-xl font-bold mb-4">
            {isAddingNewCompany
              ? "Add New Company"
              : companyDetails
              ? "Update Company Settings"
              : "Add Company Settings"}
          </Title>
          {loader ? (
            <Loader />
          ) : (
            <Tabs defaultActiveKey="1" className="bg-gray-50 p-2 rounded-lg">
              <TabPane tab="Basic Info" key="1">
                <Form
                  form={basicForm}
                  layout="vertical"
                  name="basic_settings"
                  onFinish={onFinishBasic}
                  className="space-y-2"
                >
                  <Row
                    gutter={[12, 12]}
                    className="grid grid-cols-1 md:grid-cols-3 gap-3"
                  >
                    <Col className="md:col-span-1">
                      <Form.Item
                        label="Company Logo"
                        name="company_logo"
                        className="w-full"
                      >
                        <Upload
                          listType="picture-card"
                          beforeUpload={() => false}
                          fileList={thumbFileList}
                          maxCount={1}
                          onChange={handleImageUpload}
                          accept="image/jpeg,image/png"
                          className="inline-flex items-center justify-center w-24 h-24 border-2 border-dashed border-gray-300 rounded-lg hover:border-blue-500 transition-colors"
                        >
                          {thumbFileList.length >= 1 ? null : (
                            <div className="text-center">
                              <PlusOutlined className="text-xl" />
                              <div className="text-xs">Upload</div>
                            </div>
                          )}
                        </Upload>
                      </Form.Item>
                    </Col>
                    <Col className="md:col-span-2">
                      <Row
                        gutter={[12, 12]}
                        className="grid grid-cols-1 md:grid-cols-2 gap-0"
                      >
                        <Col>
                          <Form.Item
                            label="Select Company"
                            name="selectedCompany"
                            rules={[
                              {
                                required: true,
                                message: "Please select a Company!",
                              },
                            ]}
                          >
                            <Select
                              placeholder="Select a Company"
                              {...SEARCHABLE_SELECT_PROPS}
                              allowClear
                              onChange={handleCompanyChange}
                            >
                              <Option value="add_new" label="Add New Company">
                                Add New Company
                              </Option>
                              {sortedClientCompanies.map((Company) => (
                                <Option
                                  key={Company.CompanyId}
                                  value={Company.CompanyId}
                                  label={Company.CompanyName}
                                >
                                  {Company.CompanyName}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col>
                          <Form.Item
                            label="Company Name"
                            name="CompanyName"
                            rules={[
                              {
                                required: true,
                                message: "Please input Company Name!",
                              },
                            ]}
                          >
                            <Input className="w-full rounded-lg border-gray-300 focus:border-blue-500 text-sm" />
                          </Form.Item>
                        </Col>
                        <Col>
                          <Form.Item
                            label="Company Type"
                            name="CompanyTypeId"
                            rules={[
                              {
                                required: true,
                                message: "Please select company type!",
                              },
                            ]}
                          >
                            <Select
                              className="w-full rounded-lg border-gray-300 focus:border-blue-500 text-sm"
                              placeholder="Select Company Type"
                              {...SEARCHABLE_SELECT_PROPS}
                              allowClear
                            >
                              {sortedCompanyTypes.map((type) => (
                                <Option
                                  key={type.CompanyTypeId}
                                  value={type.CompanyTypeId}
                                  label={type.CompanyTypeName}
                                >
                                  {type.CompanyTypeName}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col>
                          <Form.Item
                            label="Registered Address"
                            name="address"
                            rules={[
                              {
                                required: true,
                                message: "Please input address!",
                              },
                            ]}
                          >
                            <Input className="w-full rounded-lg border-gray-300 focus:border-blue-500 text-sm" />
                          </Form.Item>
                        </Col>
                        <Col>
                          <Form.Item
                            label="State"
                            name="state"
                            rules={[
                              {
                                required: true,
                                message: "Please select state!",
                              },
                            ]}
                          >
                            <Select
                              className="w-full rounded-lg border-gray-300 focus:border-blue-500 text-sm"
                              placeholder="Select State"
                              {...SEARCHABLE_SELECT_PROPS}
                              onChange={handleStateChange}
                              allowClear
                            >
                              {sortedStates.map((state) => (
                                <Option
                                  key={state.StateId}
                                  value={state.StateId}
                                  label={state.StateName}
                                >
                                  {state.StateName}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col>
                          <Form.Item
                            label="City"
                            name="city"
                            rules={[
                              {
                                required: true,
                                message: "Please select city!",
                              },
                            ]}
                          >
                            <Select
                              className="w-full rounded-lg border-gray-300 focus:border-blue-500 text-sm"
                              placeholder="Select City"
                              {...SEARCHABLE_SELECT_PROPS}
                              loading={loading}
                              disabled={!sortedCities.length}
                              allowClear
                            >
                              {sortedCities.map((city) => (
                                <Option
                                  key={city.CityId}
                                  value={city.CityId}
                                  label={city.CityName}
                                >
                                  {city.CityName}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col>
                          <Form.Item
                            label="Country"
                            name="country"
                            rules={[
                              {
                                required: true,
                                message: "Please select country!",
                              },
                            ]}
                          >
                            <Select
                              className="w-full rounded-lg border-gray-300 focus:border-blue-500 text-sm"
                              placeholder="Select Country"
                              {...SEARCHABLE_SELECT_PROPS}
                              disabled
                            >
                              {sortedCountries.map((country) => (
                                <Option
                                  key={country.CountryId}
                                  value={country.CountryId}
                                  label={country.CountryName}
                                >
                                  {country.CountryName}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col>
                          <Form.Item
                            label="Phone"
                            name="phone"
                            rules={[
                              {
                                required: true,
                                message: "Please input phone number!",
                              },
                              {
                                pattern: /^[0-9]{10}$/,
                                message:
                                  "Please enter a valid 10-digit phone number!",
                              },
                            ]}
                          >
                            <Input
                              addonBefore="91"
                              maxLength={10}
                              className="w-full rounded-lg border-gray-300 focus:border-blue-500 text-sm"
                            />
                          </Form.Item>
                        </Col>
                        <Col>
                          <Form.Item
                            label="Email"
                            name="email"
                            rules={[
                              {
                                required: true,
                                message: "Please input email!",
                              },
                              {
                                type: "email",
                                message: "Please enter a valid email!",
                              },
                            ]}
                          >
                            <Input className="w-full rounded-lg border-gray-300 focus:border-blue-500 text-sm" />
                          </Form.Item>
                        </Col>
                        <Col>
                          <Form.Item
                            label="Website"
                            name="website"
                            rules={[
                              {
                                type: "url",
                                message: "Please enter a valid URL!",
                              },
                            ]}
                          >
                            <Input className="w-full rounded-lg border-gray-300 focus:border-blue-500 text-sm" />
                          </Form.Item>
                        </Col>
                        <Col>
                          <Form.Item label="GST Number" name="gst_number">
                            <Input className="w-full rounded-lg border-gray-300 focus:border-blue-500 text-sm" />
                          </Form.Item>
                        </Col>
                        <Col>
                          <Form.Item label="TAN Number" name="tan_number">
                            <Input className="w-full rounded-lg border-gray-300 focus:border-blue-500 text-sm" />
                          </Form.Item>
                        </Col>
                        <Col>
                          <Form.Item label="PF Number" name="pf_number">
                            <Input className="w-full rounded-lg border-gray-300 focus:border-blue-500 text-sm" />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Form.Item>
                    <Button
                      type="primary"
                      htmlType="submit"
                      loading={loader}
                      className="mt-4 bg-blue-500 text-white hover:bg-blue-600 text-sm px-4 py-1"
                    >
                      {companyDetails && !isAddingNewCompany
                        ? "Update Basic Details"
                        : "Save Basic Details"}
                    </Button>
                  </Form.Item>
                </Form>
              </TabPane>
              <TabPane tab="Bank Info" key="2">
                <Form
                  form={bankForm}
                  layout="vertical"
                  name="bank_settings"
                  onFinish={onFinishBank}
                  className="space-y-2"
                >
                  {bankEntries.map((entry, index) => (
                    <Row
                      gutter={[12, 12]}
                      key={index}
                      className="grid grid-cols-1 md:grid-cols-3 gap-3 mb-2"
                    >
                      <Col>
                        <Form.Item
                          label="Account Name"
                          name={["bankEntries", index, "accountName"]}
                          rules={[
                            {
                              required: true,
                              message: "Please input account name!",
                            },
                          ]}
                        >
                          <Input className="w-full rounded-lg border-gray-300 focus:border-blue-500 text-sm" />
                        </Form.Item>
                      </Col>
                      <Col>
                        <Form.Item
                          label="Account Number"
                          name={["bankEntries", index, "accountNumber"]}
                          rules={[
                            {
                              required: true,
                              message: "Please input account number!",
                            },
                          ]}
                        >
                          <Input className="w-full rounded-lg border-gray-300 focus:border-blue-500 text-sm" />
                        </Form.Item>
                      </Col>
                      <Col>
                        <Form.Item
                          label="Bank Name"
                          name={["bankEntries", index, "BankTypeId"]}
                          rules={[
                            {
                              required: true,
                              message: "Please select bank name!",
                            },
                          ]}
                        >
                          <Select
                            className="w-full rounded-lg border-gray-300 focus:border-blue-500 text-sm"
                            placeholder="Select Bank"
                            {...SEARCHABLE_SELECT_PROPS}
                            allowClear
                          >
                            {sortedBanks.map((bank) => (
                              <Option
                                key={bank.BankTypeId}
                                value={bank.BankTypeId}
                                label={bank.BankTypeName}
                              >
                                {bank.BankTypeName}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col>
                        <Form.Item
                          label="Opening Balance"
                          name={["bankEntries", index, "openingBalance"]}
                        >
                          <InputNumber className="w-full rounded-lg border-gray-300 focus:border-blue-500 text-sm" />
                        </Form.Item>
                      </Col>
                      <Col>
                        <Form.Item
                          label="As on Date"
                          name={["bankEntries", index, "asOnDate"]}
                          rules={[
                            { required: true, message: "Please select date!" },
                          ]}
                        >
                          <DatePicker className="w-full rounded-lg border-gray-300 focus:border-blue-500 text-sm" />
                        </Form.Item>
                      </Col>
                      <Col>
                        {bankEntries.length > 1 && (
                          <Button
                            danger
                            onClick={() => removeBankEntry(index)}
                            className="mt-1 text-sm"
                          >
                            Remove
                          </Button>
                        )}
                      </Col>
                    </Row>
                  ))}
                  <Button
                    type="dashed"
                    onClick={addBankEntry}
                    block
                    className="bg-blue-500 text-white hover:bg-blue-600 text-sm"
                  >
                    Add Bank Entry
                  </Button>
                  <Form.Item>
                    <Button
                      type="primary"
                      htmlType="submit"
                      loading={loader}
                      className="mt-4 bg-blue-500 text-white hover:bg-blue-600 text-sm px-4 py-1"
                    >
                      {bankEntries.some((b) => b.BankId)
                        ? "Update Bank Details"
                        : "Save Bank Details"}
                    </Button>
                  </Form.Item>
                </Form>
              </TabPane>
              <TabPane tab="Company Setup" key="3">
                <Form
                  form={setupForm}
                  layout="vertical"
                  name="setup_settings"
                  onFinish={onFinishSetup}
                  className="space-y-2"
                >
                  <Row
                    gutter={[12, 12]}
                    className="grid grid-cols-1 md:grid-cols-3 gap-3 mb-4"
                  >
                    <Col>
                      <Form.Item
                        label="Financial Year"
                        name="financialYearId"
                        rules={[
                          {
                            required: true,
                            message: "Please select financial year!",
                          },
                        ]}
                      >
                        <Select
                          className="w-full rounded-lg border-gray-300 focus:border-blue-500 text-sm"
                          placeholder="Select Financial Year"
                          {...SEARCHABLE_SELECT_PROPS}
                          allowClear
                        >
                          {sortedMonths.map((month) => (
                            <Option
                              key={month.MonthId}
                              value={month.MonthId}
                              label={month.MonthName}
                            >
                              {month.MonthName}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col>
                      <Form.Item
                        label="Appraisal Year Type"
                        name="appraisalYearType"
                        rules={[
                          {
                            required: true,
                            message: "Please select appraisal year type!",
                          },
                        ]}
                      >
                        <Radio.Group
                          onChange={(e) => setAppraisalYearType(e.target.value)}
                          value={appraisalYearType}
                        >
                          <Radio value="financial">Financial Year</Radio>
                          <Radio value="calendar">Calendar Year</Radio>
                        </Radio.Group>
                      </Form.Item>
                    </Col>
                    <Col>
                      <Form.Item
                        label="Leave Year Type"
                        name="leaveYearType"
                        rules={[
                          {
                            required: true,
                            message: "Please select leave year type!",
                          },
                        ]}
                      >
                        <Radio.Group
                          onChange={(e) => setLeaveYearType(e.target.value)}
                          value={leaveYearType}
                        >
                          <Radio value="financial">Financial Year</Radio>
                          <Radio value="calendar">Calendar Year</Radio>
                        </Radio.Group>
                      </Form.Item>
                    </Col>
                  </Row>
                  <Collapse accordion>
                    <Panel header="Roles" key="1">
                      <Checkbox
                        onChange={handleSelectAllRoles}
                        checked={
                          selectedRoles.length === filteredRoles.length &&
                          filteredRoles.length > 0
                        }
                        style={{ marginBottom: 16 }}
                      >
                        Select All
                      </Checkbox>
                      <Table
                        columns={roleColumns}
                        dataSource={filteredRoles}
                        rowKey="RoleId"
                        pagination={false}
                      />
                    </Panel>
                    <Panel header="Employment Types" key="2">
                      <Checkbox
                        onChange={handleSelectAllEmploymentTypes}
                        checked={
                          selectedEmploymentTypes.length ===
                            filteredEmploymentTypes.length &&
                          filteredEmploymentTypes.length > 0
                        }
                        style={{ marginBottom: 16 }}
                      >
                        Select All
                      </Checkbox>
                      <Table
                        columns={employmentTypeColumns}
                        dataSource={filteredEmploymentTypes}
                        rowKey="EmploymentTypeId"
                        pagination={false}
                      />
                    </Panel>
                    <Panel header="Shifts" key="3">
                      <Checkbox
                        onChange={handleSelectAllShifts}
                        checked={
                          selectedShifts.length === filteredShifts.length &&
                          filteredShifts.length > 0
                        }
                        style={{ marginBottom: 16 }}
                      >
                        Select All
                      </Checkbox>
                      <Table
                        columns={shiftColumns}
                        dataSource={filteredShifts}
                        rowKey="ShiftId"
                        pagination={false}
                      />
                    </Panel>
                    <Panel header="Leave Types" key="4">
                      <Checkbox
                        onChange={handleSelectAllLeaveTypes}
                        checked={
                          selectedLeaveTypes.length ===
                            filteredLeaveTypes.length &&
                          filteredLeaveTypes.length > 0
                        }
                        style={{ marginBottom: 16 }}
                      >
                        Select All
                      </Checkbox>
                      <Table
                        columns={leaveTypeColumns}
                        dataSource={filteredLeaveTypes}
                        rowKey="LeaveTypeId"
                        pagination={false}
                      />
                    </Panel>
                    <Panel header="Department and Designation Setup" key="5">
                      <div className="mb-4">
                        <Checkbox
                          onChange={handleSelectAllDepartments}
                          checked={
                            selectedDepartments.length ===
                              filteredDepartments.length &&
                            filteredDepartments.length > 0
                          }
                          style={{ marginBottom: 16 }}
                        >
                          Select All Departments
                        </Checkbox>
                        <Table
                          columns={departmentColumns}
                          dataSource={filteredDepartments}
                          rowKey="DepartmentId"
                          pagination={false}
                        />
                      </div>
                      <div>
                        <Checkbox
                          onChange={handleSelectAllDesignations}
                          checked={
                            selectedDesignations.length ===
                              filteredDesignations.length &&
                            filteredDesignations.length > 0
                          }
                          style={{ marginBottom: 16 }}
                        >
                          Select All Designations
                        </Checkbox>
                        <Table
                          columns={designationColumns}
                          dataSource={filteredDesignations}
                          rowKey="DesignationId"
                          pagination={false}
                        />
                      </div>
                    </Panel>
                  </Collapse>
                  <Form.Item>
                    <Button
                      type="primary"
                      htmlType="submit"
                      loading={loader}
                      className="mt-4 bg-blue-500 text-white hover:bg-blue-600 text-sm px-4 py-1"
                    >
                      Save Company Setup
                    </Button>
                  </Form.Item>
                </Form>
              </TabPane>
              {!isAddingNewCompany && (
                <TabPane tab="Office Setup" key="4">
                  <Form
                    form={officeForm}
                    layout="vertical"
                    name="office_settings"
                    onFinish={onFinishOffice}
                    className="space-y-2"
                  >
                    {officeEntries.map((entry, index) => (
                      <Row
                        gutter={[12, 12]}
                        key={index}
                        className="grid grid-cols-1 md:grid-cols-3 gap-3 mb-2"
                      >
                        <Col>
                          <Form.Item
                            label="Office Type"
                            name={["officeEntries", index, "OfficeTypeId"]}
                            rules={[
                              {
                                required: true,
                                message: "Please select office type!",
                              },
                            ]}
                          >
                            <Select
                              className="w-full rounded-lg border-gray-300 focus:border-blue-500 text-sm"
                              placeholder="Select Office Type"
                              {...SEARCHABLE_SELECT_PROPS}
                              allowClear
                              onChange={(value) => {
                                setSelectedOfficeType(value);
                                if (value === 1) {
                                  officeForm.setFieldsValue({
                                    officeEntries: officeEntries.map((e, i) =>
                                      i === index
                                        ? {
                                            ...e,
                                            OfficeTypeId: value,
                                            GstNumber: "",
                                            EmailId: "",
                                            PhoneNumber: "",
                                            StreetAddress: "",
                                            CityId: undefined,
                                            StateId: undefined,
                                            CountryId: undefined,
                                            ZipCode: undefined,
                                          }
                                        : e
                                    ),
                                  });
                                }
                              }}
                            >
                              {sortedOfficeTypes.map((type) => (
                                <Option
                                  key={type.OfficeTypeId}
                                  value={type.OfficeTypeId}
                                  label={type.OfficeTypeName}
                                >
                                  {type.OfficeTypeName}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col>
                          <Form.Item
                            label="Office Name"
                            name={["officeEntries", index, "CompanyOfficeName"]}
                            rules={[
                              {
                                required: true,
                                message: "Please input office name!",
                              },
                            ]}
                          >
                            <Input className="w-full rounded-lg border-gray-300 focus:border-blue-500 text-sm" />
                          </Form.Item>
                        </Col>
                        <Col>
                          <Form.Item
                            label="Employee Code Prefix"
                            name={[
                              "officeEntries",
                              index,
                              "EmployeeCodePrefix",
                            ]}
                            rules={[
                              {
                                required: true,
                                message: "Please input employee code prefix!",
                              },
                            ]}
                          >
                            <Input className="w-full rounded-lg border-gray-300 focus:border-blue-500 text-sm" />
                          </Form.Item>
                        </Col>
                        {selectedOfficeType !== 1 && (
                          <>
                            <Col>
                              <Form.Item
                                label="GST Number"
                                name={["officeEntries", index, "GstNumber"]}
                              >
                                <Input className="w-full rounded-lg border-gray-300 focus:border-blue-500 text-sm" />
                              </Form.Item>
                            </Col>
                            <Col>
                              <Form.Item
                                label="Email"
                                name={["officeEntries", index, "EmailId"]}
                                rules={[
                                  {
                                    type: "email",
                                    message: "Please enter a valid email!",
                                  },
                                ]}
                              >
                                <Input className="w-full rounded-lg border-gray-300 focus:border-blue-500 text-sm" />
                              </Form.Item>
                            </Col>
                            <Col>
                              <Form.Item
                                label="Phone"
                                name={["officeEntries", index, "PhoneNumber"]}
                                rules={[
                                  {
                                    pattern: /^[0-9]{10}$/,
                                    message:
                                      "Please enter a valid 10-digit phone number!",
                                  },
                                ]}
                              >
                                <Input
                                  addonBefore="91"
                                  maxLength={10}
                                  className="w-full rounded-lg border-gray-300 focus:border-blue-500 text-sm"
                                />
                              </Form.Item>
                            </Col>
                            <Col>
                              <Form.Item
                                label="Street Address"
                                name={["officeEntries", index, "StreetAddress"]}
                              >
                                <Input className="w-full rounded-lg border-gray-300 focus:border-blue-500 text-sm" />
                              </Form.Item>
                            </Col>
                            <Col>
                              <Form.Item
                                label="State"
                                name={["officeEntries", index, "StateId"]}
                              >
                                <Select
                                  className="w-full rounded-lg border-gray-300 focus:border-blue-500 text-sm"
                                  placeholder="Select State"
                                  {...SEARCHABLE_SELECT_PROPS}
                                  allowClear
                                  onChange={(value) =>
                                    handleOfficeStateChange(value, index)
                                  }
                                >
                                  {sortedStates.map((state) => (
                                    <Option
                                      key={state.StateId}
                                      value={state.StateId}
                                      label={state.StateName}
                                    >
                                      {state.StateName}
                                    </Option>
                                  ))}
                                </Select>
                              </Form.Item>
                            </Col>
                            <Col>
                              <Form.Item
                                label="City"
                                name={["officeEntries", index, "CityId"]}
                              >
                                <Select
                                  className="w-full rounded-lg border-gray-300 focus:border-blue-500 text-sm"
                                  placeholder="Select City"
                                  {...SEARCHABLE_SELECT_PROPS}
                                  loading={loading}
                                  disabled={!sortedCities.length}
                                  allowClear
                                >
                                  {sortedCities.map((city) => (
                                    <Option
                                      key={city.CityId}
                                      value={city.CityId}
                                      label={city.CityName}
                                    >
                                      {city.CityName}
                                    </Option>
                                  ))}
                                </Select>
                              </Form.Item>
                            </Col>
                            <Col>
                              <Form.Item
                                label="Country"
                                name={["officeEntries", index, "CountryId"]}
                              >
                                <Select
                                  className="w-full rounded-lg border-gray-300 focus:border-blue-500 text-sm"
                                  placeholder="Select Country"
                                  {...SEARCHABLE_SELECT_PROPS}
                                  disabled
                                >
                                  {sortedCountries.map((country) => (
                                    <Option
                                      key={country.CountryId}
                                      value={country.CountryId}
                                      label={country.CountryName}
                                    >
                                      {country.CountryName}
                                    </Option>
                                  ))}
                                </Select>
                              </Form.Item>
                            </Col>
                            <Col>
                              <Form.Item
                                label="Zip Code"
                                name={["officeEntries", index, "ZipCode"]}
                              >
                                <Input className="w-full rounded-lg border-gray-300 focus:border-blue-500 text-sm" />
                              </Form.Item>
                            </Col>
                          </>
                        )}
                        <Col>
                          {officeEntries.length > 1 && (
                            <Button
                              danger
                              onClick={() => removeOfficeEntry(index)}
                              className="mt-1 text-sm"
                            >
                              Remove
                            </Button>
                          )}
                        </Col>
                      </Row>
                    ))}
                    <Button
                      type="dashed"
                      onClick={addOfficeEntry}
                      block
                      className="bg-blue-500 text-white hover:bg-blue-600 text-sm"
                    >
                      Add Office Entry
                    </Button>
                    <Form.Item>
                      <Button
                        type="primary"
                        htmlType="submit"
                        loading={loader}
                        className="mt-4 bg-blue-500 text-white hover:bg-blue-600 text-sm px-4 py-1"
                      >
                        {officeEntries.some((o) => o.CompanyOfficeId)
                          ? "Update Office Details"
                          : "Save Office Details"}
                      </Button>
                    </Form.Item>
                  </Form>
                </TabPane>
              )}
              {!isAddingNewCompany && (
                <TabPane tab="Email Configuration" key="5">
                  <EmailConfiguration selectedCompanyID={companyId} />
                </TabPane>
              )}
            </Tabs>
          )}
        </Col>
      </Row>
      <Modal
        title="Add Office Type"
        visible={isModalVisible}
        onCancel={handleCancel}
        className="rounded-lg"
      >
        <Form form={modalForm} layout="vertical">
          <Form.Item
            label="Office Type"
            name="officeType"
            rules={[{ required: true, message: "Please input office type!" }]}
          >
            <Input className="w-full rounded-lg border-gray-300 focus:border-blue-500 text-sm" />
          </Form.Item>
        </Form>
      </Modal>
    </Fragment>
  );
};

export default AddDetails;
